// Lista completa de países com DDI (código de discagem) e bandeira
export const COUNTRY_DIALS = [
  { n: 'Brasil', d: '55', f: '🇧🇷' },
  { n: 'Afeganistão', d: '93', f: '🇦🇫' }, { n: 'África do Sul', d: '27', f: '🇿🇦' },
  { n: 'Albânia', d: '355', f: '🇦🇱' }, { n: 'Alemanha', d: '49', f: '🇩🇪' },
  { n: 'Andorra', d: '376', f: '🇦🇩' }, { n: 'Angola', d: '244', f: '🇦🇴' },
  { n: 'Anguilla', d: '1264', f: '🇦🇮' }, { n: 'Antígua e Barbuda', d: '1268', f: '🇦🇬' },
  { n: 'Arábia Saudita', d: '966', f: '🇸🇦' }, { n: 'Argélia', d: '213', f: '🇩🇿' },
  { n: 'Argentina', d: '54', f: '🇦🇷' }, { n: 'Armênia', d: '374', f: '🇦🇲' },
  { n: 'Aruba', d: '297', f: '🇦🇼' }, { n: 'Austrália', d: '61', f: '🇦🇺' },
  { n: 'Áustria', d: '43', f: '🇦🇹' }, { n: 'Azerbaijão', d: '994', f: '🇦🇿' },
  { n: 'Bahamas', d: '1242', f: '🇧🇸' }, { n: 'Bahrein', d: '973', f: '🇧🇭' },
  { n: 'Bangladesh', d: '880', f: '🇧🇩' }, { n: 'Barbados', d: '1246', f: '🇧🇧' },
  { n: 'Bélgica', d: '32', f: '🇧🇪' }, { n: 'Belize', d: '501', f: '🇧🇿' },
  { n: 'Benin', d: '229', f: '🇧🇯' }, { n: 'Bermudas', d: '1441', f: '🇧🇲' },
  { n: 'Bielorrússia', d: '375', f: '🇧🇾' }, { n: 'Bolívia', d: '591', f: '🇧🇴' },
  { n: 'Bósnia e Herzegovina', d: '387', f: '🇧🇦' }, { n: 'Botsuana', d: '267', f: '🇧🇼' },
  { n: 'Brunei', d: '673', f: '🇧🇳' }, { n: 'Bulgária', d: '359', f: '🇧🇬' },
  { n: 'Burkina Faso', d: '226', f: '🇧🇫' }, { n: 'Burundi', d: '257', f: '🇧🇮' },
  { n: 'Butão', d: '975', f: '🇧🇹' }, { n: 'Cabo Verde', d: '238', f: '🇨🇻' },
  { n: 'Camarões', d: '237', f: '🇨🇲' }, { n: 'Camboja', d: '855', f: '🇰🇭' },
  { n: 'Canadá', d: '1', f: '🇨🇦' }, { n: 'Catar', d: '974', f: '🇶🇦' },
  { n: 'Cazaquistão', d: '7', f: '🇰🇿' }, { n: 'Chade', d: '235', f: '🇹🇩' },
  { n: 'Chile', d: '56', f: '🇨🇱' }, { n: 'China', d: '86', f: '🇨🇳' },
  { n: 'Chipre', d: '357', f: '🇨🇾' }, { n: 'Colômbia', d: '57', f: '🇨🇴' },
  { n: 'Comores', d: '269', f: '🇰🇲' }, { n: 'Congo', d: '242', f: '🇨🇬' },
  { n: 'Congo (RDC)', d: '243', f: '🇨🇩' }, { n: 'Coreia do Norte', d: '850', f: '🇰🇵' },
  { n: 'Coreia do Sul', d: '82', f: '🇰🇷' }, { n: 'Costa do Marfim', d: '225', f: '🇨🇮' },
  { n: 'Costa Rica', d: '506', f: '🇨🇷' }, { n: 'Croácia', d: '385', f: '🇭🇷' },
  { n: 'Cuba', d: '53', f: '🇨🇺' }, { n: 'Curaçao', d: '599', f: '🇨🇼' },
  { n: 'Dinamarca', d: '45', f: '🇩🇰' }, { n: 'Djibuti', d: '253', f: '🇩🇯' },
  { n: 'Dominica', d: '1767', f: '🇩🇲' }, { n: 'Egito', d: '20', f: '🇪🇬' },
  { n: 'El Salvador', d: '503', f: '🇸🇻' }, { n: 'Emirados Árabes Unidos', d: '971', f: '🇦🇪' },
  { n: 'Equador', d: '593', f: '🇪🇨' }, { n: 'Eritreia', d: '291', f: '🇪🇷' },
  { n: 'Eslováquia', d: '421', f: '🇸🇰' }, { n: 'Eslovênia', d: '386', f: '🇸🇮' },
  { n: 'Espanha', d: '34', f: '🇪🇸' }, { n: 'Estados Unidos', d: '1', f: '🇺🇸' },
  { n: 'Estônia', d: '372', f: '🇪🇪' }, { n: 'Eswatini', d: '268', f: '🇸🇿' },
  { n: 'Etiópia', d: '251', f: '🇪🇹' }, { n: 'Fiji', d: '679', f: '🇫🇯' },
  { n: 'Filipinas', d: '63', f: '🇵🇭' }, { n: 'Finlândia', d: '358', f: '🇫🇮' },
  { n: 'França', d: '33', f: '🇫🇷' }, { n: 'Gabão', d: '241', f: '🇬🇦' },
  { n: 'Gâmbia', d: '220', f: '🇬🇲' }, { n: 'Gana', d: '233', f: '🇬🇭' },
  { n: 'Geórgia', d: '995', f: '🇬🇪' }, { n: 'Gibraltar', d: '350', f: '🇬🇮' },
  { n: 'Granada', d: '1473', f: '🇬🇩' }, { n: 'Grécia', d: '30', f: '🇬🇷' },
  { n: 'Groenlândia', d: '299', f: '🇬🇱' }, { n: 'Guadalupe', d: '590', f: '🇬🇵' },
  { n: 'Guam', d: '1671', f: '🇬🇺' }, { n: 'Guatemala', d: '502', f: '🇬🇹' },
  { n: 'Guiana', d: '592', f: '🇬🇾' }, { n: 'Guiana Francesa', d: '594', f: '🇬🇫' },
  { n: 'Guiné', d: '224', f: '🇬🇳' }, { n: 'Guiné-Bissau', d: '245', f: '🇬🇼' },
  { n: 'Guiné Equatorial', d: '240', f: '🇬🇶' }, { n: 'Haiti', d: '509', f: '🇭🇹' },
  { n: 'Honduras', d: '504', f: '🇭🇳' }, { n: 'Hong Kong', d: '852', f: '🇭🇰' },
  { n: 'Hungria', d: '36', f: '🇭🇺' }, { n: 'Iêmen', d: '967', f: '🇾🇪' },
  { n: 'Ilhas Cayman', d: '1345', f: '🇰🇾' }, { n: 'Ilhas Faroé', d: '298', f: '🇫🇴' },
  { n: 'Ilhas Marshall', d: '692', f: '🇲🇭' }, { n: 'Ilhas Salomão', d: '677', f: '🇸🇧' },
  { n: 'Ilhas Virgens Britânicas', d: '1284', f: '🇻🇬' }, { n: 'Ilhas Virgens (EUA)', d: '1340', f: '🇻🇮' },
  { n: 'Índia', d: '91', f: '🇮🇳' }, { n: 'Indonésia', d: '62', f: '🇮🇩' },
  { n: 'Irã', d: '98', f: '🇮🇷' }, { n: 'Iraque', d: '964', f: '🇮🇶' },
  { n: 'Irlanda', d: '353', f: '🇮🇪' }, { n: 'Islândia', d: '354', f: '🇮🇸' },
  { n: 'Israel', d: '972', f: '🇮🇱' }, { n: 'Itália', d: '39', f: '🇮🇹' },
  { n: 'Jamaica', d: '1876', f: '🇯🇲' }, { n: 'Japão', d: '81', f: '🇯🇵' },
  { n: 'Jordânia', d: '962', f: '🇯🇴' }, { n: 'Kosovo', d: '383', f: '🇽🇰' },
  { n: 'Kuwait', d: '965', f: '🇰🇼' }, { n: 'Laos', d: '856', f: '🇱🇦' },
  { n: 'Lesoto', d: '266', f: '🇱🇸' }, { n: 'Letônia', d: '371', f: '🇱🇻' },
  { n: 'Líbano', d: '961', f: '🇱🇧' }, { n: 'Libéria', d: '231', f: '🇱🇷' },
  { n: 'Líbia', d: '218', f: '🇱🇾' }, { n: 'Liechtenstein', d: '423', f: '🇱🇮' },
  { n: 'Lituânia', d: '370', f: '🇱🇹' }, { n: 'Luxemburgo', d: '352', f: '🇱🇺' },
  { n: 'Macau', d: '853', f: '🇲🇴' }, { n: 'Macedônia do Norte', d: '389', f: '🇲🇰' },
  { n: 'Madagascar', d: '261', f: '🇲🇬' }, { n: 'Malásia', d: '60', f: '🇲🇾' },
  { n: 'Malawi', d: '265', f: '🇲🇼' }, { n: 'Maldivas', d: '960', f: '🇲🇻' },
  { n: 'Mali', d: '223', f: '🇲🇱' }, { n: 'Malta', d: '356', f: '🇲🇹' },
  { n: 'Marrocos', d: '212', f: '🇲🇦' }, { n: 'Martinica', d: '596', f: '🇲🇶' },
  { n: 'Maurício', d: '230', f: '🇲🇺' }, { n: 'Mauritânia', d: '222', f: '🇲🇷' },
  { n: 'México', d: '52', f: '🇲🇽' }, { n: 'Mianmar', d: '95', f: '🇲🇲' },
  { n: 'Micronésia', d: '691', f: '🇫🇲' }, { n: 'Moçambique', d: '258', f: '🇲🇿' },
  { n: 'Moldávia', d: '373', f: '🇲🇩' }, { n: 'Mônaco', d: '377', f: '🇲🇨' },
  { n: 'Mongólia', d: '976', f: '🇲🇳' }, { n: 'Montenegro', d: '382', f: '🇲🇪' },
  { n: 'Namíbia', d: '264', f: '🇳🇦' }, { n: 'Nepal', d: '977', f: '🇳🇵' },
  { n: 'Nicarágua', d: '505', f: '🇳🇮' }, { n: 'Níger', d: '227', f: '🇳🇪' },
  { n: 'Nigéria', d: '234', f: '🇳🇬' }, { n: 'Noruega', d: '47', f: '🇳🇴' },
  { n: 'Nova Caledônia', d: '687', f: '🇳🇨' }, { n: 'Nova Zelândia', d: '64', f: '🇳🇿' },
  { n: 'Omã', d: '968', f: '🇴🇲' }, { n: 'Países Baixos', d: '31', f: '🇳🇱' },
  { n: 'Palau', d: '680', f: '🇵🇼' }, { n: 'Palestina', d: '970', f: '🇵🇸' },
  { n: 'Panamá', d: '507', f: '🇵🇦' }, { n: 'Papua-Nova Guiné', d: '675', f: '🇵🇬' },
  { n: 'Paquistão', d: '92', f: '🇵🇰' }, { n: 'Paraguai', d: '595', f: '🇵🇾' },
  { n: 'Peru', d: '51', f: '🇵🇪' }, { n: 'Polinésia Francesa', d: '689', f: '🇵🇫' },
  { n: 'Polônia', d: '48', f: '🇵🇱' }, { n: 'Porto Rico', d: '1787', f: '🇵🇷' },
  { n: 'Portugal', d: '351', f: '🇵🇹' }, { n: 'Quênia', d: '254', f: '🇰🇪' },
  { n: 'Quirguistão', d: '996', f: '🇰🇬' }, { n: 'Reino Unido', d: '44', f: '🇬🇧' },
  { n: 'República Centro-Africana', d: '236', f: '🇨🇫' }, { n: 'República Dominicana', d: '1809', f: '🇩🇴' },
  { n: 'República Tcheca', d: '420', f: '🇨🇿' }, { n: 'Reunião', d: '262', f: '🇷🇪' },
  { n: 'Romênia', d: '40', f: '🇷🇴' }, { n: 'Ruanda', d: '250', f: '🇷🇼' },
  { n: 'Rússia', d: '7', f: '🇷🇺' }, { n: 'Samoa', d: '685', f: '🇼🇸' },
  { n: 'San Marino', d: '378', f: '🇸🇲' }, { n: 'Santa Lúcia', d: '1758', f: '🇱🇨' },
  { n: 'São Cristóvão e Névis', d: '1869', f: '🇰🇳' }, { n: 'São Tomé e Príncipe', d: '239', f: '🇸🇹' },
  { n: 'São Vicente e Granadinas', d: '1784', f: '🇻🇨' }, { n: 'Seicheles', d: '248', f: '🇸🇨' },
  { n: 'Senegal', d: '221', f: '🇸🇳' }, { n: 'Serra Leoa', d: '232', f: '🇸🇱' },
  { n: 'Sérvia', d: '381', f: '🇷🇸' }, { n: 'Singapura', d: '65', f: '🇸🇬' },
  { n: 'Síria', d: '963', f: '🇸🇾' }, { n: 'Somália', d: '252', f: '🇸🇴' },
  { n: 'Sri Lanka', d: '94', f: '🇱🇰' }, { n: 'Sudão', d: '249', f: '🇸🇩' },
  { n: 'Sudão do Sul', d: '211', f: '🇸🇸' }, { n: 'Suécia', d: '46', f: '🇸🇪' },
  { n: 'Suíça', d: '41', f: '🇨🇭' }, { n: 'Suriname', d: '597', f: '🇸🇷' },
  { n: 'Tailândia', d: '66', f: '🇹🇭' }, { n: 'Taiwan', d: '886', f: '🇹🇼' },
  { n: 'Tajiquistão', d: '992', f: '🇹🇯' }, { n: 'Tanzânia', d: '255', f: '🇹🇿' },
  { n: 'Timor-Leste', d: '670', f: '🇹🇱' }, { n: 'Togo', d: '228', f: '🇹🇬' },
  { n: 'Tonga', d: '676', f: '🇹🇴' }, { n: 'Trinidad e Tobago', d: '1868', f: '🇹🇹' },
  { n: 'Tunísia', d: '216', f: '🇹🇳' }, { n: 'Turcomenistão', d: '993', f: '🇹🇲' },
  { n: 'Turquia', d: '90', f: '🇹🇷' }, { n: 'Ucrânia', d: '380', f: '🇺🇦' },
  { n: 'Uganda', d: '256', f: '🇺🇬' }, { n: 'Uruguai', d: '598', f: '🇺🇾' },
  { n: 'Uzbequistão', d: '998', f: '🇺🇿' }, { n: 'Vanuatu', d: '678', f: '🇻🇺' },
  { n: 'Vaticano', d: '379', f: '🇻🇦' }, { n: 'Venezuela', d: '58', f: '🇻🇪' },
  { n: 'Vietnã', d: '84', f: '🇻🇳' }, { n: 'Zâmbia', d: '260', f: '🇿🇲' },
  { n: 'Zimbábue', d: '263', f: '🇿🇼' },
];

// Tira o DDI da frente SÓ se o que sobrar ainda for um número válido.
// Protege DDD que começa com o próprio DDI (ex.: +55 55 99935-7503, DDD 55 do RS).
const semDdi = (w, d) => {
  if (!d || !w.startsWith(d)) return null;
  const resto = w.slice(d.length);
  if (d === '55') return resto.length === 10 || resto.length === 11 ? resto : null;
  return resto.length >= 6 && d.length + resto.length <= 15 ? resto : null;
};

// Separa um whatsapp armazenado em { dial, number }.
// Contas antigas (BR sem DDI, 10-11 dígitos) são tratadas como Brasil.
export const splitWhatsapp = (whatsapp, dialHint) => {
  const w = (whatsapp || '').replace(/\D/g, '');
  const hint = (dialHint || '').replace(/\D/g, '');
  if (hint) {
    const resto = semDdi(w, hint);
    return { dial: hint, number: resto === null ? w : resto };
  }
  if (w.length === 10 || w.length === 11) return { dial: '55', number: w };
  const dials = [...new Set(COUNTRY_DIALS.map((c) => c.d))].sort((a, b) => b.length - a.length);
  for (const d of dials) {
    const resto = semDdi(w, d);
    if (resto !== null) return { dial: d, number: resto };
  }
  return { dial: '55', number: w };
};

export const formatWhatsapp = (whatsapp, dialHint) => {
  const w = (whatsapp || '').replace(/\D/g, '');
  if (!w) return '—';
  if (!dialHint && (w.length === 10 || w.length === 11)) return w; // legado BR sem DDI
  const { dial, number } = splitWhatsapp(w, dialHint);
  return `+${dial} ${number}`;
};
